import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ClosedStoreOrders from "./closed";
import DeliveredStoreOrders from "./delivered";
import ShippedStoreOrders from "./shipped";
import UnShippedStoreOrders from "./unShipped";
import { getOutletFromCookies } from "../../../../../utils/Auth";

const tabs = [
  { name: "Shipped", href: "shipped" },
  { name: "Unshipped", href: "unshipped" },
  { name: "Delivered", href: "delivered" },
  { name: "Closed", href: "closed" },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function StoreOrders() {
  const outlet = getOutletFromCookies();
  const navigate = useNavigate();
  const DEFAULT_ACTIVE_TAB = "shipped";
  const { active_tab } = useParams();

  useEffect(() => {
    if (!active_tab) {
      navigate(`/admin/${outlet?.store_name}/orders/${DEFAULT_ACTIVE_TAB}/1`);
    }
  });

  const toggle = (tab) => {
    if (active_tab !== tab) {
      navigate(`/admin/${outlet?.store_name}/orders/${tab.href}/1`);
    }
  };

  return (
    <div className="store-page" data-test="storeOrder-page">
      <div className="sm:block">
        <div className="border-b border-gray-200 dark:border-none">
          <nav
            className="-mb-px flex space-x-8 overflow-x-scroll sm:overflow-hidden"
            aria-label="Tabs"
          >
            {tabs.map((tab) => (
              <button
                key={tab.name}
                onClick={() => {
                  toggle(tab);
                }}
                className={classNames(
                  tab.href === active_tab
                    ? "border-primary text-primary font-bold"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300",
                  "whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm"
                )}
                aria-current={tab.href === active_tab ? "page" : undefined}
              >
                {tab.name}
              </button>
            ))}
          </nav>
        </div>
      </div>
      <div>
        {active_tab === "shipped" && <ShippedStoreOrders />}
        {active_tab === "unshipped" && <UnShippedStoreOrders />}
        {active_tab === "closed" && <ClosedStoreOrders />}
        {active_tab === "delivered" && <DeliveredStoreOrders />}
      </div>
    </div>
  );
}
